import React from 'react';
import PhotosHeader from './photos-header';
import PhotoList from './photo-list';


class Photos extends React.Component {
	render() {
		const { props } = this;

		return (
			<div className="grid-x">
				<div className="cell small-12">
					<PhotosHeader { ...props } />
				</div>
				<div className="cell small-12">
					<PhotoList { ...props } />
				</div>
			</div>
		);
	}
}

export default Photos;
